export const ItemStatusEnum = Object.freeze({
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
});

export const BenefitTypeEnum = Object.freeze({
  ACCESS: "ACCESS",
  CREDITS: "CREDITS",
});
